// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/hip.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";

/**
 * @generated from message knop.ui.v1.api.HipTasksResponse
 */
export class HipTasksResponse extends Message<HipTasksResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.api.HipTask hip_tasks = 1;
   */
  hipTasks: HipTask[] = [];

  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 2;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<HipTasksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.HipTasksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hip_tasks", kind: "message", T: HipTask, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HipTasksResponse {
    return new HipTasksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HipTasksResponse {
    return new HipTasksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HipTasksResponse {
    return new HipTasksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: HipTasksResponse | PlainMessage<HipTasksResponse> | undefined, b: HipTasksResponse | PlainMessage<HipTasksResponse> | undefined): boolean {
    return proto3.util.equals(HipTasksResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.HipTask
 */
export class HipTask extends Message<HipTask> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: knop.ui.v1.api.HipTask.TaskStatus status = 2;
   */
  status = HipTask_TaskStatus.UNKNOWN;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 3;
   */
  requestedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration maximum_computation_time = 4;
   */
  maximumComputationTime?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp task_started_at = 5;
   */
  taskStartedAt?: Timestamp;

  /**
   * @generated from field: string scenario_hub = 6;
   */
  scenarioHub = "";

  /**
   * @generated from field: google.protobuf.Timestamp scenario_start = 7;
   */
  scenarioStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scenario_end = 8;
   */
  scenarioEnd?: Timestamp;

  /**
   * @generated from field: uint32 number_of_conflicts = 9;
   */
  numberOfConflicts = 0;

  /**
   * @generated from field: optional uint32 queue_position = 10;
   */
  queuePosition?: number;

  /**
   * @generated from field: string correlation_hip_id = 11;
   */
  correlationHipId = "";

  /**
   * @generated from field: string correlation_operation_id = 12;
   */
  correlationOperationId = "";

  /**
   * @generated from field: string correlation_parent_id = 13;
   */
  correlationParentId = "";

  /**
   * @generated from field: optional knop.ui.v1.api.HipTask.FailureReason failure_reason = 14;
   */
  failureReason?: HipTask_FailureReason;

  constructor(data?: PartialMessage<HipTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.HipTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(HipTask_TaskStatus) },
    { no: 3, name: "requested_at", kind: "message", T: Timestamp },
    { no: 4, name: "maximum_computation_time", kind: "message", T: Duration },
    { no: 5, name: "task_started_at", kind: "message", T: Timestamp },
    { no: 6, name: "scenario_hub", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "scenario_start", kind: "message", T: Timestamp },
    { no: 8, name: "scenario_end", kind: "message", T: Timestamp },
    { no: 9, name: "number_of_conflicts", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10, name: "queue_position", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 11, name: "correlation_hip_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "correlation_operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "correlation_parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "failure_reason", kind: "enum", T: proto3.getEnumType(HipTask_FailureReason), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HipTask {
    return new HipTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HipTask {
    return new HipTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HipTask {
    return new HipTask().fromJsonString(jsonString, options);
  }

  static equals(a: HipTask | PlainMessage<HipTask> | undefined, b: HipTask | PlainMessage<HipTask> | undefined): boolean {
    return proto3.util.equals(HipTask, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.api.HipTask.TaskStatus
 */
export enum HipTask_TaskStatus {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: IN_QUEUE = 1;
   */
  IN_QUEUE = 1,

  /**
   * @generated from enum value: RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: FAILED_WITH_RESULT = 4;
   */
  FAILED_WITH_RESULT = 4,

  /**
   * @generated from enum value: FAILED = 5;
   */
  FAILED = 5,

  /**
   * @generated from enum value: SENT_TO_DONNA = 6;
   */
  SENT_TO_DONNA = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(HipTask_TaskStatus)
proto3.util.setEnumType(HipTask_TaskStatus, "knop.ui.v1.api.HipTask.TaskStatus", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "IN_QUEUE" },
  { no: 2, name: "RUNNING" },
  { no: 3, name: "COMPLETED" },
  { no: 4, name: "FAILED_WITH_RESULT" },
  { no: 5, name: "FAILED" },
  { no: 6, name: "SENT_TO_DONNA" },
]);

/**
 * @generated from enum knop.ui.v1.api.HipTask.FailureReason
 */
export enum HipTask_FailureReason {
  /**
   * @generated from enum value: FAILURE_REASON_UNKNOWN = 0;
   */
  FAILURE_REASON_UNKNOWN = 0,

  /**
   * @generated from enum value: UNSPECIFIED = 1;
   */
  UNSPECIFIED = 1,

  /**
   * @generated from enum value: NO_MATCHING = 2;
   */
  NO_MATCHING = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(HipTask_FailureReason)
proto3.util.setEnumType(HipTask_FailureReason, "knop.ui.v1.api.HipTask.FailureReason", [
  { no: 0, name: "FAILURE_REASON_UNKNOWN" },
  { no: 1, name: "UNSPECIFIED" },
  { no: 2, name: "NO_MATCHING" },
]);

/**
 * @generated from message knop.ui.v1.api.OpenHipPlanByTaskIdRequest
 */
export class OpenHipPlanByTaskIdRequest extends Message<OpenHipPlanByTaskIdRequest> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  constructor(data?: PartialMessage<OpenHipPlanByTaskIdRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.OpenHipPlanByTaskIdRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenHipPlanByTaskIdRequest {
    return new OpenHipPlanByTaskIdRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenHipPlanByTaskIdRequest {
    return new OpenHipPlanByTaskIdRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenHipPlanByTaskIdRequest {
    return new OpenHipPlanByTaskIdRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OpenHipPlanByTaskIdRequest | PlainMessage<OpenHipPlanByTaskIdRequest> | undefined, b: OpenHipPlanByTaskIdRequest | PlainMessage<OpenHipPlanByTaskIdRequest> | undefined): boolean {
    return proto3.util.equals(OpenHipPlanByTaskIdRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.OpenHipPlanByTaskIdResponse
 */
export class OpenHipPlanByTaskIdResponse extends Message<OpenHipPlanByTaskIdResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  /**
   * @generated from field: string correlation_operation_id = 4;
   */
  correlationOperationId = "";

  /**
   * @generated from field: string correlation_parent_id = 5;
   */
  correlationParentId = "";

  /**
   * @generated from field: string correlation_current_id = 6;
   */
  correlationCurrentId = "";

  constructor(data?: PartialMessage<OpenHipPlanByTaskIdResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.OpenHipPlanByTaskIdResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "correlation_operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "correlation_parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "correlation_current_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenHipPlanByTaskIdResponse {
    return new OpenHipPlanByTaskIdResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenHipPlanByTaskIdResponse {
    return new OpenHipPlanByTaskIdResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenHipPlanByTaskIdResponse {
    return new OpenHipPlanByTaskIdResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OpenHipPlanByTaskIdResponse | PlainMessage<OpenHipPlanByTaskIdResponse> | undefined, b: OpenHipPlanByTaskIdResponse | PlainMessage<OpenHipPlanByTaskIdResponse> | undefined): boolean {
    return proto3.util.equals(OpenHipPlanByTaskIdResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.HideHipPlanByTaskIdRequest
 */
export class HideHipPlanByTaskIdRequest extends Message<HideHipPlanByTaskIdRequest> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  constructor(data?: PartialMessage<HideHipPlanByTaskIdRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.HideHipPlanByTaskIdRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HideHipPlanByTaskIdRequest {
    return new HideHipPlanByTaskIdRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HideHipPlanByTaskIdRequest {
    return new HideHipPlanByTaskIdRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HideHipPlanByTaskIdRequest {
    return new HideHipPlanByTaskIdRequest().fromJsonString(jsonString, options);
  }

  static equals(a: HideHipPlanByTaskIdRequest | PlainMessage<HideHipPlanByTaskIdRequest> | undefined, b: HideHipPlanByTaskIdRequest | PlainMessage<HideHipPlanByTaskIdRequest> | undefined): boolean {
    return proto3.util.equals(HideHipPlanByTaskIdRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.HideHipPlanByTaskIdResponse
 */
export class HideHipPlanByTaskIdResponse extends Message<HideHipPlanByTaskIdResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  constructor(data?: PartialMessage<HideHipPlanByTaskIdResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.HideHipPlanByTaskIdResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HideHipPlanByTaskIdResponse {
    return new HideHipPlanByTaskIdResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HideHipPlanByTaskIdResponse {
    return new HideHipPlanByTaskIdResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HideHipPlanByTaskIdResponse {
    return new HideHipPlanByTaskIdResponse().fromJsonString(jsonString, options);
  }

  static equals(a: HideHipPlanByTaskIdResponse | PlainMessage<HideHipPlanByTaskIdResponse> | undefined, b: HideHipPlanByTaskIdResponse | PlainMessage<HideHipPlanByTaskIdResponse> | undefined): boolean {
    return proto3.util.equals(HideHipPlanByTaskIdResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.GenerateSolutionRequest
 */
export class GenerateSolutionRequest extends Message<GenerateSolutionRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  /**
   * @generated from field: google.protobuf.Duration maximum_computation_time = 2;
   */
  maximumComputationTime?: Duration;

  /**
   * @generated from field: bool stop_when_feasible = 3;
   */
  stopWhenFeasible = false;

  constructor(data?: PartialMessage<GenerateSolutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.GenerateSolutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "maximum_computation_time", kind: "message", T: Duration },
    { no: 3, name: "stop_when_feasible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateSolutionRequest {
    return new GenerateSolutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateSolutionRequest {
    return new GenerateSolutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateSolutionRequest {
    return new GenerateSolutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateSolutionRequest | PlainMessage<GenerateSolutionRequest> | undefined, b: GenerateSolutionRequest | PlainMessage<GenerateSolutionRequest> | undefined): boolean {
    return proto3.util.equals(GenerateSolutionRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.GenerateSolutionResponse
 */
export class GenerateSolutionResponse extends Message<GenerateSolutionResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string failure_description = 2;
   */
  failureDescription = "";

  /**
   * @generated from field: repeated string to_hip_conversion_errors = 3;
   */
  toHipConversionErrors: string[] = [];

  constructor(data?: PartialMessage<GenerateSolutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.GenerateSolutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "failure_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to_hip_conversion_errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateSolutionResponse {
    return new GenerateSolutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateSolutionResponse {
    return new GenerateSolutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateSolutionResponse {
    return new GenerateSolutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateSolutionResponse | PlainMessage<GenerateSolutionResponse> | undefined, b: GenerateSolutionResponse | PlainMessage<GenerateSolutionResponse> | undefined): boolean {
    return proto3.util.equals(GenerateSolutionResponse, a, b);
  }
}

